import { TranscriptFocus } from '../../../coaching-base/general';
import { BehaviourItem } from '../../../coaching-tags/models/behaviour.coaching.model';
import { SubBehaviourItem } from '../../../coaching-tags/models/subbehaviour.coaching.model';
import { BehaviourTag } from '../model/behaviour-tag.model';

export function createFocusTags(
    focuses: TranscriptFocus[],
    behaviours: BehaviourItem[],
    subBehaviours: SubBehaviourItem[],
): BehaviourTag[] {
    return (
        focuses?.map((e) => ({
            behaviour: behaviours?.find((ee) => ee.id === e.behaviourId),
            subBehaviour: subBehaviours?.find(
                (ee) =>
                    ee.id === e.subBehaviourId &&
                    ee.behaviourId === e.behaviourId,
            ),
            isChecked: true,
        })) ?? []
    );
}
